import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { createRoot } from 'react-dom/client';
import React from 'react';
import './applicationInsights';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);

root.render(
    <React.StrictMode>
        <BrowserRouter basename={baseUrl ?? undefined}>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
